import React from 'react'
import {
  Constants,
  Icon,
  Label,
  useContainerDimensionsContext,
} from '@therms/atalaya'
import { DateTime, RPCDocs } from '@therms/react-modules'
import classNames from 'classnames'
import { MdTimer } from 'react-icons/md'

interface TagsTabProps {
  record: RPCDocs.Records.GetRecordProfile.v1.Record
}

function TagsTab({ record }: TagsTabProps) {
  const {
    viewport: { width: viewportWidth },
  } = useContainerDimensionsContext()
  const isMobileLayout = viewportWidth < Constants.Breakpoint.Sm.width

  const { dateSensitiveTags, tags } = record

  return (
    <div>
      <div className="rounded bg-surface-subtle p-base">
        <div className="font-medium uppercase tracking-wide text-color-subtle">
          Date Sensitive
        </div>

        {dateSensitiveTags?.length ? (
          <div className="mt-sm flex flex-col gap-base">
            {dateSensitiveTags.map(({ activeDate, expireDate, tag }) => (
              <div className="flex gap-sm">
                <div
                  className="w-xxs shrink-0 self-stretch"
                  style={{ backgroundColor: tag.color }}
                />

                <div
                  className={classNames(
                    { 'flex-col': isMobileLayout },
                    'flex flex-1 gap-sm',
                  )}
                  key={`${tag.title}${activeDate}`}
                >
                  <div className="flex-1 basis-0">
                    <Label>Title</Label>
                    <div>
                      <span>{tag.title}</span>
                    </div>
                  </div>

                  <div className="flex-1 basis-0">
                    <Label>Active</Label>
                    <div>
                      <DateTime mode="date" timestamp={activeDate} />
                    </div>
                  </div>

                  <div className="flex-1 basis-0">
                    <Label>Expire</Label>
                    <div>
                      {expireDate ? (
                        <DateTime mode="date" timestamp={expireDate} />
                      ) : (
                        <span className="text-color-subtle">Permanent</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="mt-lg flex items-center space-x-base">
            <div className="grow border-t border-border" />

            <div className="flex items-center opacity-50">
              <Icon className="mr-xxs" Icon={MdTimer} size="lg" />
              <span className="tracking-wide">No date sensitive tags</span>
            </div>

            <div className="grow border-t border-border" />
          </div>
        )}
      </div>

      <div className="mt-base px-base">
        <div className="flex items-center justify-between">
          <div className="font-medium uppercase tracking-wide text-color-subtle">
            Current
          </div>
        </div>

        <div className="mt-sm space-y-xs">
          {tags.map((tag) => (
            <div className="flex space-x-base" key={tag.title}>
              <div
                className="w-xxs self-stretch"
                style={{ backgroundColor: tag.color }}
              />

              <div>{tag.title}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export { TagsTab }
